import { BasePayloadMapper } from '@ps/utils';

import { SurveyPerformanceFilters } from '../../models/survey-performance-report.model';

export interface SurveyPerformanceReportRequestDto {
  buyers: { id: number; name: string }[];
  status: { id: number }[];
}

export class SurveyPerformanceReportPayloadMapper extends BasePayloadMapper<
  SurveyPerformanceFilters,
  SurveyPerformanceReportRequestDto
> {
  public toPayload(
    filters: SurveyPerformanceFilters,
  ): SurveyPerformanceReportRequestDto {
    return {
      buyers: filters.buyers.map((buyer) => ({
        id: buyer.id,
        name: buyer.name,
      })),
      status: filters.statusIds.map((id) => ({ id })),
    };
  }
}
